var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__select"},[_c('span',{staticClass:"select__subtitle form-group"},[_vm._v("\n    Критерий поиска:\n  ")]),_vm._v(" "),_c('Select',{staticClass:"select__input_criterion",attrs:{"options":_vm.searchCriterionsList,"default-key":_vm.defaultKey,"z-index":3000},on:{"input":_vm.setCriterion}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd1e4ce8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_shared/features/search/TypeCriterion.vue
// module id = null
// module chunks = 